const message = {
    RecentSearch: "最近搜索"
};

export default message;
